import React from 'react'
import { Redirect } from "react-router-dom";
import Header from './header';
import Footer from './footer';

function AdminAfterLogin() {
  let authuser = sessionStorage.getItem('Key_Veriable')
  console.log(authuser)
  if (authuser == null) {
    return (<Redirect to="/login" />)
  }
  else {
    let name ="ADMIN"
    console.log(name)
    return (
      <div>
        <Header />
        <br />
        <h3 className="this">ADMIN DASHBOARD</h3>
        <h3 className="this">WELCOME {name}</h3>
        <h3>While Booking your beast today with Bike Rentals, </h3>
        <h3> we assure to provide top class Service and</h3>
        <h3> a heaven for all the travel enthusiasts </h3>
        <h3>to curb that wanderlust.</h3>
        <h3 className="this">THIS IS ADMIN DASH BOARD</h3>
        <Footer />
      </div>
    )
  }
}

export default AdminAfterLogin
